import { useMemo } from "react";
import { UserInformation } from "../../api/it/account/account-api-state";

type SearchType = {
    id: number;
    name: string;
} | null;

interface Props {
    users?: UserInformation[];
    searchValue: string;
    searchType: SearchType;
}

export function useFilteredUsers({ users, searchValue, searchType, }: Props) {
    return useMemo(() => {
        const search = searchValue.trim().toLowerCase();

        if (!users) return [];
        if (!search) return users;

        return users.filter((user) => {
            switch (searchType?.name) {
                case "Email":
                    return (user.email ?? "").toLowerCase().includes(search);

                case "Name":
                    return `${user.firstname ?? ""} ${user.lastname ?? ""}`
                        .toLowerCase()
                        .includes(search);

                case "Department":
                    return (user.department?.name ?? "").toLowerCase().includes(search);

                case "Role":
                    return (user.role?.name ?? "").toLowerCase().includes(search);

                default:
                    return true;
            }
        });
    }, [users, searchValue, searchType]);
}